var WamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ViewApplicationDetailsWComponent } from "../../../application/view-application/modules/w/view-application-details-w/view-application-details-w.component";
import { ViewApplicationLocationWComponent } from "../../../application/view-application/modules/w/view-application-location-w/view-application-location-w.component";
import { CreateApplicationDetailsWComponent } from "../../../application/create-application/modules/w/create-application-details-w/create-application-details-w.component";
import { CreateApplicationLocationWComponent } from "../../../application/create-application/modules/w/create-application-location-w/create-application-location-w.component";
import { CreateApplicationProfessionalBodiesWComponent } from "../../../application/create-application/modules/w/create-application-professional-bodies-w/create-application-professional-bodies-w.component";
import { ViewApplicationProfessionalBodiesWComponent } from "../../../application/view-application/modules/w/view-application-professional-bodies-w/view-application-professional-bodies-w.component";
import { ApiWayleaveConstants } from "../../constants/api-constants/api-wayleave.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// TODO these columns will be added back when we do advanced searches
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var WamsSearchOptions;
(function (WamsSearchOptions) {
    WamsSearchOptions["ReferenceNumber"] = "Reference Number";
    WamsSearchOptions["MyApplications"] = "My Applications";
    WamsSearchOptions["ApplicantAgent"] = "Applicant Agent";
    WamsSearchOptions["ApplicantInfo"] = "Applicant Information";
    WamsSearchOptions["AppID"] = "Application ID";
    WamsSearchOptions["ApplicationStatus"] = "Application Status";
    WamsSearchOptions["ApplicationCategory"] = "Application Category";
    WamsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    WamsSearchOptions["AssignedToUsers"] = "Assigned to";
    WamsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    WamsSearchOptions["CreatedDate"] = "Created Date";
    WamsSearchOptions["CreatedDateRange"] = "Created Date Range";
    WamsSearchOptions["StartDate"] = "Started Date";
    WamsSearchOptions["StartDateRange"] = "Started Date Range";
    WamsSearchOptions["DaysUntilExpired"] = "Days until Expired";
    WamsSearchOptions["PercentageComplete"] = "Percentage Complete";
    WamsSearchOptions["TimeoutStatus"] = "Timeout Status";
    WamsSearchOptions["JobID"] = "Job ID";
})(WamsSearchOptions || (WamsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ClientReferenceNumber"] = "Client Reference Number";
    ApplicationHeadingEnum["Description"] = "Description";
    ApplicationHeadingEnum["ProposedStartDate"] = "Proposed Start Date";
    ApplicationHeadingEnum["ProposedEndDate"] = "Proposed End Date";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ClientReferenceNumber, "clientReferenceNumber"],
    [ApplicationHeadingEnum.Description, "description"],
    [ApplicationHeadingEnum.ProposedStartDate, "proposedStartDate"],
    [ApplicationHeadingEnum.ProposedEndDate, "proposedEndDate"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const WamsSearchQueryLookup = new Map([
    [WamsSearchOptions.AppID, "appId"],
    [WamsSearchOptions.ReferenceNumber, "referenceNumber"],
    [WamsSearchOptions.JobID, "jobId"]
]);
export const WamsAdditionalSearchOptions = [WamsSearchOptions.MyApplications,
    WamsSearchOptions.AssignedToUsers,
    WamsSearchOptions.UnassignedApplications,
    WamsSearchOptions.ApplicationsWithoutStartDate];
export const WamsDateSearchOptions = new Map([
    [WamsSearchOptions.CreatedDate, 1],
    [WamsSearchOptions.CreatedDateRange, 2],
]);
export const WamsStartRangeDateSearchOptions = new Map([
    [WamsSearchOptions.StartDate, 1],
    [WamsSearchOptions.StartDateRange, 2],
]);
export const WamsStatusSearchOptions = new Map([
    [WamsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [WamsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [WamsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [WamsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const WamsSearchOptionClientHeight = new Map([
    [WamsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [WamsSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [WamsSearchOptions.AppID, SearchContainerHeight.Simple],
    [WamsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [WamsSearchOptions.ApplicantAgent, SearchContainerHeight.Extended],
    [WamsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended]
]);
// TODO: Other tables?
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var WamsSearchOptionTableListEnum;
(function (WamsSearchOptionTableListEnum) {
    WamsSearchOptionTableListEnum["Application"] = "W_APPLICATION|Application";
    WamsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    WamsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    WamsSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
})(WamsSearchOptionTableListEnum || (WamsSearchOptionTableListEnum = {}));
export const WExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_W;
export const WTableNameListForSearchOptions = WamsSearchOptionTableListEnum.Application
    + "," + WamsSearchOptionTableListEnum.Status
    + "," + WamsSearchOptionTableListEnum.Applicant
    + "," + WamsSearchOptionTableListEnum.ApplicantAgent;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const WamsRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let WamsStrategyService = class WamsStrategyService extends AflaModuleStrategyService {
    static { WamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.Wayleaves;
    modulePrefix = ModulePrefix.Wayleaves;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiWayleaveConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = WExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = WExpandListForApplicationSearch;
    searchOptionTableNameList = WTableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Property help",
        "Application help",
        "Agent help",
        "Professional bodies help",
        "Required documentation help",
        "Notes help",
        "Communication help",
        "Applicant help",
        "Summary help",
        "Create application status page",
        "View application status page"
    ];
    setApplicantAndApplicantAgentAction = ApiWayleaveConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    createApplicationWamsSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.WAYLEAVE_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = WamsRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, WExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = WamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = WamsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = WamsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(WamsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(WamsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = WamsDateSearchOptions;
        this.RangeSearchOptions = WamsStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = WamsStatusSearchOptions;
        this.clientHeightMap = WamsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: WamsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: WamsStrategyService_1.getRecipientName(WamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: WamsStrategyService_1.getRecipientName(WamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            clientReferenceNumber: application.clientReferenceNumber,
            description: application.description,
            proposedStartDate: application.proposedStartDate !== null
                ? this.saShortDatePipe.transform(application.proposedStartDate)
                : "",
            proposedEndDate: application.proposedEndDate !== null
                ? this.saShortDatePipe.transform(application.proposedEndDate)
                : "",
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                // case "properties":
                                //   if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                //     fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                //   }
                                //   break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // 3rd level tables
        // const propertyDetails = ["owners", "applicationzonings", "propertybuildings"];
        // if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
        //   if (application.properties.length > 0) {
        //     application.properties.forEach((property) => {
        //       for (const [propkey, propVal] of Object.entries(property)) {
        //         if (propkey.toLowerCase() === appGroup.toLowerCase()
        //           || (propkey.toLowerCase().endsWith( "zonings") && appGroup.toLowerCase().endsWith("zonings"))
        //           || (propkey.toLowerCase().endsWith( "buildings") && appGroup.toLowerCase().endsWith("buildings"))) {
        //           propVal.forEach((value) => {
        //             for (const [groupKey, groupValue] of Object.entries(value)) {
        //               if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
        //                 fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
        //               }
        //             }
        //           })
        //         }
        //       }
        //     })
        //   }
        // }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(WamsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsWComponent,
            ],
            [
                ViewApplicationMenuHeadings.ProfessionalBodies,
                ViewApplicationProfessionalBodiesWComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationWComponent,
            ]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsWComponent,
            ],
            [
                CreateApplicationMenuHeadings.ProfessionalBodies,
                CreateApplicationProfessionalBodiesWComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationWComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [WamsSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [WamsSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [WamsSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [WamsSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [WamsSearchOptions.StartDate, SearchStartDateComponent],
            [WamsSearchOptions.StartDateRange, SearchStartDateComponent],
            [WamsSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [WamsSearchOptions.PercentageComplete, SearchStatusComponent],
            [WamsSearchOptions.ApplicationStatus, SearchStatusComponent],
            [WamsSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [WamsSearchOptions.TimeoutStatus, SearchStatusComponent],
            [WamsSearchOptions.DaysUntilExpired, SearchStatusComponent],
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = WamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), WamsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = WamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, WamsStrategyService_1.buildModuleIDFilter(moduleID), WamsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = WamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateWamsApplication");
        const application = this.buildApplication();
        this.createApplicationWamsSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(WamsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateWamsApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateWamsApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, applicationLines, applicationPolygons",
            $expand: "applicationLines, applicationPolygons",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
    }
    postApplicationService(params) {
        return this.http.post(ApiWayleaveConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                services: new FormControl(null),
                clientReferenceNumber: new FormControl(null, [Validators.required]),
                applicantTelecommunicationLicenseNumber: new FormControl(null),
                scopeOfWork: new FormControl(null, [Validators.required]),
                estimatedConstructionCost: new FormControl(null, [Validators.required]),
                applicationFee: new FormControl(null, [Validators.required]),
                constructionPeriod: new FormControl(null),
                constructionPeriodUnits: new FormControl(null),
                proposedStartDate: new FormControl(null, [Validators.required]),
                proposedEndDate: new FormControl(null, [Validators.required]),
                laneClosureIsRequired: new FormControl(null, [Validators.required]),
                laneClosureExtent: new FormControl(null, [Validators.required]),
                electricalServices: new FormControl(null, [Validators.required]),
                actualStartDate: new FormControl(null),
                actualEndDate: new FormControl(null),
                isResubmission: new FormControl(null),
                referenceNumber: new FormControl(null),
                previousReferenceNumber: new FormControl(null),
                acceptControl: new FormControl(null, [Validators.required])
            }),
            professionalBodiesForm: new FormGroup({
                implementingAgentRecipient: new FormControl(null),
                engineerRecipients: new FormControl(null),
                responsibleContractorRecipient: new FormControl(null),
                markImplementingAgentAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToImplementingAgent: new FormControl(null),
                markEngineerAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToEngineer: new FormControl(null),
                markContractorAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToContractor: new FormControl(null)
            }),
            locationForm: new FormGroup({
                selectedGraphic: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                polyline: new FormControl(null),
                polygon: new FormControl(null),
                polylineDto: new FormControl(null),
                polygonDto: new FormControl(null)
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        let implementingAgentRecipient = null;
        const professionalBodiesFormControl = this.form.get("professionalBodiesForm").get("implementingAgentRecipient");
        const copyApplicantDetailsToImplementingAgent = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToImplementingAgent").value;
        const markImplementingAgentAsNotApplicable = this.form.get("professionalBodiesForm").get("markImplementingAgentAsNotApplicable").value;
        if (copyApplicantDetailsToImplementingAgent) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, professionalBodiesFormControl, true);
        }
        if (copyApplicantDetailsToImplementingAgent === true || markImplementingAgentAsNotApplicable === true) {
            const implementingAgentRecipientFormValue = this.form.get("professionalBodiesForm").get("implementingAgentRecipient").value;
            implementingAgentRecipient = RecipientUtils.removeRecipientProperties(implementingAgentRecipientFormValue);
        }
        let engineerRecipient = null;
        const engineerRecipientsFormControl = this.form.get("professionalBodiesForm").get("engineerRecipients");
        const copyApplicantDetailsToEngineer = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToEngineer").value;
        const markEngineerAsNotApplicable = this.form.get("professionalBodiesForm").get("markEngineerAsNotApplicable").value;
        if (copyApplicantDetailsToEngineer) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, engineerRecipientsFormControl, true);
        }
        if (copyApplicantDetailsToEngineer === true || markEngineerAsNotApplicable === true) {
            const engineerRecipientsFormValue = this.form.get("professionalBodiesForm").get("engineerRecipients").value;
            engineerRecipient = RecipientUtils.removeRecipientProperties(engineerRecipientsFormValue);
        }
        let responsibleContractorRecipient = null;
        const responsibleContractorRecipientFormControl = this.form.get("professionalBodiesForm").get("responsibleContractorRecipient");
        const copyApplicantDetailsToContractor = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToContractor").value;
        const markContractorAsNotApplicable = this.form.get("professionalBodiesForm").get("markContractorAsNotApplicable").value;
        if (copyApplicantDetailsToContractor) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, responsibleContractorRecipientFormControl, true);
        }
        if (copyApplicantDetailsToContractor === true || markContractorAsNotApplicable === true) {
            const responsibleContractorRecipientFormValue = this.form.get("professionalBodiesForm").get("responsibleContractorRecipient").value;
            responsibleContractorRecipient = RecipientUtils.removeRecipientProperties(responsibleContractorRecipientFormValue);
        }
        const isResubmissionSelection = this.form.get("detailsForm").get("isResubmission").value;
        let markForResubmission = false;
        if (isResubmissionSelection === SharedConstants.YES_NO_ENUM.Yes) {
            markForResubmission = true;
        }
        else {
            markForResubmission = false;
        }
        const centroid = this.form.get("locationForm").get("centroid").value;
        const polyline = this.form.get("locationForm").get("polyline").value;
        const polygon = this.form.get("locationForm").get("polygon").value;
        const application = {
            referenceNumber: "",
            isResubmission: markForResubmission,
            previousReferenceNumber: this.form.get("detailsForm").get("previousReferenceNumber").value,
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            clientReferenceNumber: this.form.get("detailsForm").get("clientReferenceNumber").value,
            licenceNumber: this.form.get("detailsForm").get("applicantTelecommunicationLicenseNumber").value,
            scopeOfWork: this.form.get("detailsForm").get("scopeOfWork").value,
            estimatedCost: this.form.get("detailsForm").get("estimatedConstructionCost").value,
            applicationFee: this.form.get("detailsForm").get("applicationFee").value,
            constructionPeriod: this.form.get("detailsForm").get("constructionPeriod").value,
            constructionPeriodUnits: this.form.get("detailsForm").get("constructionPeriodUnits").value,
            proposedStartDate: this.form.get("detailsForm").get("proposedStartDate").value,
            proposedEndDate: this.form.get("detailsForm").get("proposedEndDate").value,
            laneClosureRequired: this.form.get("detailsForm").get("laneClosureIsRequired").value,
            laneClosureExtent: this.form.get("detailsForm").get("laneClosureExtent").value,
            electricalServices: this.form.get("detailsForm").get("electricalServices").value,
            description: this.form.get("detailsForm").get("description").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value,
            services: this.form.get("detailsForm").get("services").value,
            shape: WktConverterUtils.ConvertArcGISJsonToWkt(centroid),
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            implementingAgent: [],
            engineer: [],
            contractor: [],
            notes: [],
            applicationLines: [],
            applicationPolygons: [],
            applicantAgentNa: !markApplicantAgentAsNotApplicable,
            implementingAgentNa: !markImplementingAgentAsNotApplicable,
            engineerNa: !markEngineerAsNotApplicable,
            contractorNa: !markContractorAsNotApplicable,
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        if (copyApplicantDetailsToImplementingAgent === true || markImplementingAgentAsNotApplicable === true) {
            application.implementingAgent.push(implementingAgentRecipient);
        }
        if (copyApplicantDetailsToEngineer === true || markEngineerAsNotApplicable === true) {
            application.engineer.push(engineerRecipient);
        }
        if (copyApplicantDetailsToContractor === true || markContractorAsNotApplicable === true) {
            application.contractor.push(responsibleContractorRecipient);
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        if (polygon !== null) {
            const applicationPolygon = {
                wkid: 102100,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(polygon)
            };
            application.applicationPolygons.push(applicationPolygon);
        }
        if (polyline !== null) {
            const applicationLine = {
                wkid: 102100,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(polyline)
            };
            application.applicationLines.push(applicationLine);
        }
        return application;
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_W_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_W_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_W_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId,
            category
        };
        return this.http.get(`${ApiWayleaveConstants.URL}/${moduleId}/${ApiWayleaveConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiWayleaveConstants.URL}/${jobId}/${ApiWayleaveConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
WamsStrategyService = WamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], WamsStrategyService);
export { WamsStrategyService };
